const META_PIXEL_ID = '1633530854517344'

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

export function initMetaPixel(): void {
  if (window.fbq) return

  const n: any = (window.fbq = function (...args: unknown[]) {
    if (n.callMethod) {
      n.callMethod(...args)
    } else {
      n.queue.push(args)
    }
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as unknown[][]

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  window.fbq('init', META_PIXEL_ID)
}

export function trackPageView(): void {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart(): void {
  if (window.fbq) {
    window.fbq('track', 'AddToCart')
  }
}
